export default "__VITE_ASSET__DFw8vFc$__"